export const settings = {
  apiURL: "https://mayatxupload.com/mayaUp", // ✅ MayaUp için
  customzonApiURL: "https://customzonpod.com/mayaUp", // ✅ CustomZonPod için
  // localJiffy : "http://localhost/JiffyEmails",
  jiffyAPI: "https://mayatxupload.com/JiffyEmails", // ✅ JiffyEmails için yeni URL
  siteName: "MAYA UP",
  siteUrl: "https://www.mayatxupload.com",
  email: "info@txmaya.com",
  phone: "+1 (512)-800-4655",
  address: "7696 183A Toll Rd. Building 1 Suite F, Leander, TX, 78641",
};
